"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPresenter;
var _SingleSelectionPresenter = _interopRequireDefault(require("./SingleSelectionPresenter"));
var _MultiSelectionPresenter = _interopRequireDefault(require("./MultiSelectionPresenter"));
var _MultiSelectionAllAsReservedPresenter = _interopRequireDefault(require("./MultiSelectionAllAsReservedPresenter"));
var _TaggedPresenter = _interopRequireDefault(require("./TaggedPresenter"));
var _AllSelectedValueType = _interopRequireDefault(require("./AllSelectedValueType"));
function createMultiSelectionPresenter(i18n, multiSelectionOptions) {
  return multiSelectionOptions.allSelectedValueType === _AllSelectedValueType["default"].RESERVED_VALUE ? new _MultiSelectionAllAsReservedPresenter["default"](i18n) : new _MultiSelectionPresenter["default"](i18n);
}
function createPresenter(_ref) {
  var i18n = _ref.i18n,
    multiSelectionOptions = _ref.multiSelectionOptions,
    type = _ref.type,
    omitSelectedOption = _ref.omitSelectedOption,
    suppressInnerEmptyMenu = _ref.suppressInnerEmptyMenu;
  switch (type) {
    case 'single':
      return new _SingleSelectionPresenter["default"](i18n);
    case 'multiple':
      return createMultiSelectionPresenter(i18n, multiSelectionOptions);
    case 'tag':
      return new _TaggedPresenter["default"](i18n, !!omitSelectedOption, !!suppressInnerEmptyMenu);
    default:
      throw new Error('Unknown dropdown renderer type.');
  }
}